'use strict';

import Cookies from 'js-cookie';
import { loadJS } from './asset-loaders';
import InterNACHI from 'shared/InterNACHI.js';

const session = Cookies.get('session-js');

if (session) {
	loadJS(session, { async: false, defer: false });
} else {
	loadJS('/dynamic/js/session/0/0.js', { async: false, defer: false });
}

InterNACHI.session.onLoaded(() => {
	try {
		localStorage.setItem('internachi_session', JSON.stringify({
			session_js: session,
			logged_in_user: window.logged_in_user,
		}));
	} catch (e) {
		console.error(e);
	}
});

InterNACHI.session.onGuest(() => {
	try {
		localStorage.setItem('internachi_session', JSON.stringify({
			session_js: null,
			logged_in_user: null,
		}));
	} catch (e) {
		console.error(e);
	}
});
